import { createContext, useState, useContext, useCallback } from "react";
import PropTypes from "prop-types";

export const ReviewTranslationContext = createContext({});

export const ReviewTranslationProvider = ({ children }) => {
  const [translationStates, setTranslationStates] = useState({});

  const getReviewTranslationState = useCallback(
    (reviewId) => {
      return (
        translationStates[reviewId] || {
          showTranslated: false,
          translation: null,
        }
      );
    },
    [translationStates],
  );

  const setReviewTranslationState = useCallback((reviewId, translationData) => {
    setTranslationStates((prev) => ({
      ...prev,
      [reviewId]: {
        showTranslated: translationData.showTranslated ?? false,
        translation: translationData.translation ?? null,
      },
    }));
  }, []);

  const clearReviewTranslationState = useCallback((reviewId) => {
    setTranslationStates((prev) => {
      const nextTranslationStates = { ...prev };
      delete nextTranslationStates[reviewId];
      return nextTranslationStates;
    });
  }, []);

  const clearAllTranslationStates = useCallback(() => {
    setTranslationStates({});
  }, []);

  return (
    <ReviewTranslationContext.Provider
      value={{
        getReviewTranslationState,
        setReviewTranslationState,
        clearReviewTranslationState,
        clearAllTranslationStates,
      }}
    >
      {children}
    </ReviewTranslationContext.Provider>
  );
};

ReviewTranslationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const useReviewTranslationContext = () =>
  useContext(ReviewTranslationContext);
